const isDesktop = window.matchMedia('(min-width: 992px)').matches;
const isMobile = window.matchMedia('(max-width: 428px)').matches;

const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

export { isDesktop, isMobile, isTouchDevice };
